const state = {
    filters: {},
};

const mutations = {
    SET_FILTERS(state, { key, data }) {
        state.filters[key] = data;
    }
};

const actions = {
    saveSearch({ commit }, { key, data }) {
        commit('SET_FILTERS', { key, data });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};